import appendData from "common/utility";
import {
  del,
  get,
  getWithExportFile,
  post,
  postAsForm,
  put,
  patch
} from "helpers/api_helper";


export const blockUnblockUser = (id, isBlocked) => {
  const payload = typeof isBlocked === "boolean" ? { isBlocked } : {};
  return patch(`/admin/users/${id}/block`, payload);
};

export const updateUser = (userId, data) => {
  return patch(`/admin/users/${userId}`, data);
};
export const getPropertiesByUser = (
  userId,
  pageNumber,
  pageSize,
  filter = "",
  fromDate = "",
  toDate = ""
) => {
  return getWithExportFile(
    `/admin/users/${userId}/properties?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${filter}&startDate=${fromDate}&endDate=${toDate}`
  );
  
};

export const getEnquiriesByUser = (
  userId,
  pageNumber,
  pageSize,
  filter = "",
  fromDate = "",
  toDate = "",
  exportRequest = "false"
) => {
  return getWithExportFile(
    `/admin/users/${userId}/enquiries?pageNumber=${pageNumber}&pageLimit=${pageSize}&search=${filter}&userId=${userId}&startDate=${fromDate}&endDate=${toDate}&exportRequest=${exportRequest}`
  );
};

export const reSendOtp = (data) => {
  return post("/admin/resendotp", data);
};


export const forgetPassword = (data) => {
  return post("/admin/forgotPassword", data);
};

export const verifyOtp = (data) => {
  return post("/admin/verifyotp-reset", data);
};

export const resetPassword = (new_password, token) => {
  return post(
    "/admin/resetPassword",
    { new_password },
    {
      headers: {
        // Ensure backend receives a proper Bearer token
        Authorization: token?.startsWith("Bearer ") ? token : `Bearer ${token}`,
      },
    }
  );
};

export const getAllUser = (
  pageNumber,
  pageSize,
  filter,
  fromDate,
  toDate,
  isBlocked = "",
  kycStatus = "",
  exportRequest = ""
) => {
  return getWithExportFile(
    `/admin/users?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}&isBlocked=${isBlocked}&kycStatus=${kycStatus}&exportCSV=${exportRequest}`
  );
};
export const getAllAgents = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate,
  analytics = false,
  dateRangeType = "",
  sortBy = "",
  alphabetical = "",
  brokerId = ""
) => {
  let url = `/admin/agents?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}`;
  
  if (analytics) {
    url += `&analytics=true`;
    if (dateRangeType) url += `&dateRangeType=${dateRangeType}`;
    if (sortBy) url += `&sorting=true`;
    if (alphabetical) url += `&alphabetical=${alphabetical}`;
  }
  
  // Add broker ID for role-based filtering
  if (brokerId) {
    url += `&id=${brokerId}`;
  }
  
  console.log("getAllAgents API call with URL:", url);
  return getWithExportFile(url);
};

export const createAgent = (data) => {
  return post(`/admin/agents`, data);
};

export const updateAgent = (agentId, data) => {
  return patch(`/admin/agents/${agentId}`, data);
};
export const updateBroker = (brokerId, data) => {
  return patch(`/admin/brokerages/${brokerId}`, data);
};
export const createBroker = (data) => {
  return post(`/admin/brokers`, data);
};

export const blockUnblockAgent = (agentId, isBlocked) => {
  const payload = typeof isBlocked === "boolean" ? { isBlocked } : {};
  return patch(`/admin/agents/${agentId}/block`, payload);
};

export const updateAgentShowAi = (agentId, showAi) => {
  return put(`/admin/agent/${agentId}/show-ai`, { showAi });
};

export const blockUnblockBroker = (brokerId, isBlocked) => {
  const payload = typeof isBlocked === "boolean" ? { isBlocked } : {};
  return patch(`/admin/brokerages/${brokerId}/block`, payload);
};

export const updateBrokerSubscription = (brokerId, subscriptionRequired) => {
  return put(`/admin/broker/${brokerId}/subscription-required`, { subscriptionRequired });
};

export const getBrokerSubscription = (brokerId) => {
  return get(`/admin/broker/${brokerId}/subscription-required`);
};

export const updateBrokerShowAi = (brokerId, showAi) => {
  return put(`/admin/broker/${brokerId}/show-ai`, { showAi });
};
export const dashboardStats = () => {
  return get("/admin/dashboard/stats");
};








// export const addNewFaq = (data) => {
//   return post("/cms/home/faq", data);
// };
// export const getProgrammedSavingsServices = (
//   pageNumber,
//   pageSize,
//   filter = "",
//   exportRequest = "false"
// ) => {
//   return getWithExportFile(
//     `/service/getAllServices?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${filter}&exportCSV=${exportRequest}`
//   );
// };
// export const addProgrammedSavingsServices = (data) => {
//   return post("/service/saveServices", data);
// };
// export const addNewPlans = (data) => {
//   return post("/plan/createPlan", data);
// };
// export const updateServiceStatus = (data) => {
//   return put("/service/updateService", data);
// };
export const deleteClientUser = (data) => {
  console.log(data);
  return del(`/admin/users/${data.params.userId}`,null, data);
};

export const deleteAgent = (data) => {
  return del(`/admin/agents/${data.params.adminId}`,null, data);
};



// export const updateNewFaq = (data) => {
//   return post("/admin/saveFaq", data);
// };
// export const updateNewPlan = (data) => {
//   return post("/plan/createPlan", data);
// };

// export const getFaqDetail = () => {
//   return get("/cms/home/getFaq");
// };
// export const getPlanDetail = () => {
//   return get("/plan/getAllPlans");
// };

// export const deleteFaqData = (data) => {
//   return del("/admin/deleteFaq", data);
// };
// export const deleteServiceData = (data) => {
//   return del("", data);
// };
// export const deletePlanData = (data) => {
//   return del("/plan/deletePlan", data);
// };





// export const getUserProfile = () => {
//   return get("/admin/me");
// };


// export const getAllQueries = (
//   pageNumber,
//   pageSize,
//   filter = "",
//   filter2 = "",
//   fromDate = "",
//   toDate = ""
// ) => {
//   return getWithExportFile(
//     `/admin/getAllClientQueries?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${filter}&filter2=${filter2}&fromDate=${fromDate}&toDate=${toDate}`
//   );
// };

// export const getAllKycRequests = (
//   pageNumber,
//   pageSize,
//   filter = "",
//   filter2 = "",
//   fromDate = "",
//   toDate = ""
// ) => {
//   return getWithExportFile(
//     `/admin/kycUserslist?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${filter2}&startDate=${fromDate}&endDate=${toDate}`
//   );
// };
// export const getAllTransactions = (pageNumber, pageSize) => {
//   return getWithExportFile(
//     `/transaction/getAllTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}`
//   );
// };

// export const updateProfile = (data) => {
//   return post("/admin/update", data);
// };
// export const updateUserDetail = (data) => {
//   return post("/admin/updateUserDetail", data);
// };    

// export const queryStatusChange = (data) => {
//   return put("/admin/updateContactUsStatus", data);
// };

// export const updateProfileImage = (data) => {
//   const formData = appendData(data);
//   return postAsForm("/admin/uploadImage", formData);
// };
// export const getKycPdf = () => {
//   return get("client/getKycDocument");
// };
// export const uploadKycPdf = (data) => {
//   const formData = appendData(data);
//   return postAsForm("/admin/saveKycDocument", formData);
// };

// export const changePassword = (data) => {
//   return post("/admin/changePassword", data);
// };

// export const csmUpdateFlow = (data) => {
//   return post("/admin/csm/update", data);
// };
// export const getCsmFlow = (type) => {
//   return get("/admin/csm/detail?type=" + type);
// };

// export const getUserGraphData = () => {
//   return get("Dashboard/getuserOnBoardData");
// };
// export const transactionGraph = (type) => {
//   return get("admin/transactionGraph");
// };
// export const getWithdrawGraphData = () => {
//   return get("Dashboard/getMoneyWithdrawData");
// };
// export const getDepositGraphData = () => {
//   return get("Dashboard/getMoneyDepositData");
// };
// export const userStorageInfo = (userId) => {
//   return get("admin/userStorage?userId=" + userId);
// };
// export const getServiceDetail = (id) => {
//   return get("client/service/detail?serviceId=" + id);
// };
// export const userTransactionsInfo = (userId) => {
//   return get("admin/userTransactions?userId=" + userId);
// };

// export const kycStatusUpdate = (data) => {
//   return put("/admin/updateKycStatus", data);
// };

// export const savingServiceDetailOneServiceOfUser = (userId, serviceId) => {
//   return get(
//     `/service/getInvestedSchemeDetailsByAdmin?id=${userId}&serviceId=${serviceId}`
//   );
// };

// export const getNotifications = () => {
//   return get("admin/getAdminNotification");
// };
